export type AppConfig = {
    buildEnvironment: string
    luigiApiBaseUrl: string
}

const buildEnvironment: string = process.env.ENV_BUILD_ENVIRONMENT!

export const appConfig: AppConfig = {
    buildEnvironment,
    luigiApiBaseUrl: process.env.ENV_LUIGI_BASE_URL!,
}
